<h3 mat-dialog-title>
    Zeitspanne für Export auswählen
</h3>
<mat-dialog-content>
    <div class="flex flex-col" *ngIf="Diaries; else loading">
        <ng-container *ngIf="!DialogData.DiaryType">
            <mat-slide-toggle [formControl]="FormGroup.controls.zusatzarbeiten">
                Zusatzarbeiten exportieren
            </mat-slide-toggle>
            <mat-slide-toggle [formControl]="FormGroup.controls.dokumentation">
                Dokumentationen exportieren
            </mat-slide-toggle>
            <mat-slide-toggle [formControl]="FormGroup.controls.auffaelligkeiten">
                Auffälligkeiten exportieren
            </mat-slide-toggle>
            <mat-slide-toggle [formControl]="FormGroup.controls.mangel">
                Mängel exportieren
            </mat-slide-toggle>
            <mat-slide-toggle [formControl]="FormGroup.controls.erschwernis">
                Erschwernisse exportieren
            </mat-slide-toggle>
            <mat-slide-toggle [formControl]="FormGroup.controls.bedenken">
                Bedenkenanzeigen exportieren
            </mat-slide-toggle>
            <mat-slide-toggle [formControl]="FormGroup.controls.bautagebuch">
                Bautagebuch exportieren
            </mat-slide-toggle>
        </ng-container>
<!--        <mat-form-field class="example-full-width">-->
<!--            <mat-label>von</mat-label>-->
<!--            <input matInput [matDatepicker]="picker" [formControl]="DateForm" (click)="picker.open()" />-->
<!--            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--            <mat-datepicker [dateClass]="DateClass" #picker></mat-datepicker>-->
<!--        </mat-form-field>-->
<!--        <mat-form-field class="example-full-width">-->
<!--            <mat-label>bis</mat-label>-->
<!--            <input matInput [matDatepicker]="picker2" [formControl]="ToDateForm" (click)="picker2.open()" [min]="DateForm.value"/>-->
<!--            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->
<!--            <mat-datepicker [dateClass]="DateClass" #picker2 ></mat-datepicker>-->
<!--        </mat-form-field>-->

        <mat-form-field>
            <mat-label>Zeitraum</mat-label>
            <mat-date-range-input
                [rangePicker]="timespanPicker"
                (click)="timespanPicker.open()">
                <input matStartDate placeholder="Von" [formControl]="DateForm">
                <input matEndDate placeholder="Bis" [formControl]="ToDateForm">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="timespanPicker"></mat-datepicker-toggle>
            <mat-date-range-picker [dateClass]="DateClass" #timespanPicker></mat-date-range-picker>
        </mat-form-field>

        <ng-container *ngIf="FormGroup.controls.bautagebuch.value">
            <p *ngIf="DiaryCount$ | async as count">{{count === 1 ? 'Ein Bautagebucheintrag' : count + ' Bautagebucheinträge'}} für den Export ausgewählt</p>
            <p *ngIf="!(DiaryCount$ | async)">Keine Bautagebucheinträge für den Export ausgewählt</p>
        </ng-container>
        <!--
        <ng-container *ngIf="FormGroup.controls.zusatzarbeiten.value">
            <p *ngIf="NachnahmenCount$ | async as count">{{count === 1 ? 'Eine Zusatzarbeit' : count + ' Zusatzarbeiten'}} für den Export ausgewählt</p>
            <p *ngIf="!(NachnahmenCount$ | async)">Keine Zusatzarbeiten für den Export ausgewählt</p>
        </ng-container>
        <ng-container *ngIf="FormGroup.controls.dokumentation.value">
            <p *ngIf="DokumentationCount$ | async as count">{{count === 1 ? 'Eine Dokumentation' : count + ' Dokumentationen'}} für den Export ausgewählt</p>
            <p *ngIf="!(DokumentationCount$ | async)">Keine Dokumentation für den Export ausgewählt</p>
        </ng-container>
        <ng-container *ngIf="FormGroup.controls.regiearbeit.value">
            <p *ngIf="RegiearbeitCount$ | async as count">{{count === 1 ? 'Eine Regiearbeit' : count + ' Regiearbeiten'}} für den Export ausgewählt</p>
            <p *ngIf="!(RegiearbeitCount$ | async)">Keine Regiearbeiten für den Export ausgewählt</p>
        </ng-container>
        <ng-container *ngIf="FormGroup.controls.auffaelligkeiten.value">
            <p *ngIf="AuffaelligCount$ | async as count">{{count === 1 ? 'Eine Auffälligkeit' : count + ' Auffälligkeiten'}} für den Export ausgewählt</p>
            <p *ngIf="!(AuffaelligCount$ | async)">Keine Auffälligkeiten für den Export ausgewählt</p>
        </ng-container>
        <ng-container *ngIf="FormGroup.controls.mangel.value">
            <p *ngIf="MangelCount$ | async as count">{{count === 1 ? 'Einen Mangel' : count + ' Mängel'}} für den Export ausgewählt</p>
            <p *ngIf="!(MangelCount$ | async)">Keine Mängel für den Export ausgewählt</p>
        </ng-container>
        <ng-container *ngIf="FormGroup.controls.erschwernis.value">
            <p *ngIf="ErschwernisCount$ | async as count">{{count === 1 ? 'Ein Erschwernis' : count + ' Erschwernisse'}} für den Export ausgewählt</p>
            <p *ngIf="!(ErschwernisCount$ | async)">Keine Mängel für den Export ausgewählt</p>
        </ng-container>
        <ng-container *ngIf="FormGroup.controls.bedenken.value">
            <p *ngIf="BedenkenCount$ | async as count">{{count === 1 ? 'Eine Bedenkenanzeige' : count + ' Bedenkenanzeigen'}} für den Export ausgewählt</p>
            <p *ngIf="!(BedenkenCount$ | async)">Keine Bedenkenanzeigen für den Export ausgewählt</p>
        </ng-container>
        -->

        <div *ngIf="!FormGroup.controls.bautagebuch.value">
            <div class="exportTable-button">
                <button
                    app-round-button
                    matTooltip="Filter"
                    aria-label="Filter"
                    (click)="$event.stopPropagation();
                    filter.Open()" [matBadge]="FilterAmount$ | async"
                    [matBadgeHidden]="!(FilterAmount$ | async)"
                    >
                    <fa-icon icon="filter"></fa-icon>
                </button>
                <app-filter-card
                    #filter
                    UnlimitedHeight
                    [Settings]="FilterSettings$ | async"
                    [Values]="FilterValues$ | async"
                    (ValuesChange)="FilterValues$.next($event)"
                    (click)="$event.stopPropagation()">
                </app-filter-card>
            </div>
            <!-- Export Table -->
            <mat-dialog-content *ngIf="DataSource$ | async as data" class="exportTable" matSort>
                <table mat-table [dataSource]="data" style="width: 100%;">
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="checkbox">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox
                                (change)="$event ? toggleAllCheckboxes(data) : null"
                                [checked]="selection.hasValue() && isAllSelected(data)"
                                [indeterminate]="selection.hasValue() && !isAllSelected(data)"
                            ></mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox
                                (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)"
                            ></mat-checkbox>
                        </td>
                    </ng-container>
                    <!-- Data Column -->
                    <ng-container *ngFor="let column of TableColumns" [matColumnDef]="column.name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.header }}</th>
                        <td mat-cell *matCellDef="let rowData">{{ rowData[column.name] }}</td>
                    </ng-container>
                    <!-- Header Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></tr>
                </table>
            </mat-dialog-content>
        </div>

        <mat-expansion-panel class="mb-2">
            <mat-expansion-panel-header>
                erweiterte Einstellungen
            </mat-expansion-panel-header>
            <!--    ähnliches template auch in export-event-dialog.component.html -->
            <div class="flex flex-col">
                <mat-slide-toggle [formControl]="FormGroup.controls.exportWorkTimes">Arbeitszeiten mit exportieren</mat-slide-toggle>
                <mat-slide-toggle [formControl]="FormGroup.controls.showFooter">Fußzeile anzeigen</mat-slide-toggle>
                <div class="flex items-center">
                    <label id="image-quality-label">Bild Qualität:</label>
                    <mat-radio-group aria-labelledby="image-quality-label" [formControl]="FormGroup.controls.imageQuality">
                        <mat-radio-button class="m-2" [value]="o.value" *ngFor="let o of imageQualityOptions">{{o.label}}</mat-radio-button>
                    </mat-radio-group>
                    <mat-form-field *ngIf="FormGroup.value.imageQuality === imageQualityEnum.custom">
                        <mat-label>Auflösung</mat-label>
                        <input matInput [placeholder]="defaultResizePixel+''" type="number" min="1" [formControl]="FormGroup.controls.imageQualityPX">
                        <span matSuffix="px"></span>
                        <mat-hint>standard ist {{defaultResizePixel}}px</mat-hint>
                    </mat-form-field>
                </div>
                <div class="flex items-center">
                    <label id="image-col-count-label">Bilder nebeneinander:</label>
                    <mat-radio-group
                        aria-labelledby="image-col-count-label"
                        [formControl]="FormGroup.controls.imageColCount">
                        <mat-radio-button class="m-2" [value]="1">1</mat-radio-button>
                        <mat-radio-button class="m-2" [value]="2">2</mat-radio-button>
                        <mat-radio-button class="m-2" [value]="3">3</mat-radio-button>
                    </mat-radio-group>
                </div>
<!--                todo D277-4955-->
<!--                <div class="flex items-center">-->
<!--                    <label id="image-min-row-count-label">Bilder übereinander (min. pro Seite):</label>-->
<!--                    <mat-radio-group-->
<!--                        aria-labelledby="image-min-row-count-label"-->
<!--                        [formControl]="FormGroup.controls.imageMinRowCount">-->
<!--                        <mat-radio-button class="m-2" [value]="1">1</mat-radio-button>-->
<!--                        <mat-radio-button class="m-2" [value]="2">2</mat-radio-button>-->
<!--                        <mat-radio-button class="m-2" [value]="3">3</mat-radio-button>-->
<!--                    </mat-radio-group>-->
<!--                </div>-->
            </div>
        </mat-expansion-panel>
    </div>
</mat-dialog-content>
<div mat-dialog-actions>
    <button app-button Inverted mat-dialog-close [IsLoading]="LS.IsLoading$ | async" Color="cancel">Abbrechen</button>
    <!--
    <button app-button [Disabled]="
    (!FormGroup.controls.zusatzarbeiten.value && !FormGroup.controls.auffaelligkeiten.value && !FormGroup.controls.dokumentation.value && !(DiaryCount$ | async))
     || FormGroup.controls.zusatzarbeiten.value && !(NachnahmenCount$ | async)
     || FormGroup.controls.auffaelligkeiten.value && !(AuffaelligCount$ | async)
     || FormGroup.controls.dokumentation.value && !(DokumentationCount$ | async)
     || FormGroup.controls.regiearbeit.value && !(RegiearbeitCount$ | async)
     || FormGroup.invalid" [IsLoading]="LS.IsLoading$ | async" (click)="Submit()"
     >
        Exportieren
    </button>
    -->
    <button app-button
        [Disabled]="
            selection.selected.length <= 0 && !FormGroup.controls.bautagebuch.value ||
            !(DiaryCount$ | async) && FormGroup.controls.bautagebuch.value"
        [IsLoading]="LS.IsLoading$ | async"
        (click)="Submit()"
    >
        Exportieren
    </button>
</div>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
